var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myDocument",staticStyle:{"background-color":"#f5f5f5 !important","width":"auto","min-height":"100%"}},[_c('Navbar'),_c('router-view',{key:_vm.$route.path})],1)}
var staticRenderFns = []

export { render, staticRenderFns }